"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogStore = void 0;
// TODO: fix dismiss throwing Unhandled rejection
// TODO: tests with stacking/store

class Dialog {
  constructor(params, container) {
    this.params = params;
    this.params.context = params.context || {};
    this.params.context.dialog = this;
    this.params.context.store = container.store;
    this.container = container;
    this.result = new Promise((resolve, reject) => {
      this._deffered = {
        resolve,
        reject
      };
    });
  }
  close(result) {
    this.container.pop();
    this._deffered.resolve(result);
  }
  dismiss(reason) {
    this.container.pop();
    this._deffered.reject(reason);
  }
}
class DialogStore {
  constructor(store) {
    this.store = store;
    this.dialogs = [];
    this.listeners = [];
  }
  addListener(listener) {
    this.listeners.push(listener);
  }
  removeListener(listener) {
    this.listeners = this.listeners.filter(f => f !== listener);
  }
  notify() {
    this.listeners.map(l => l(this));
  }
  open(params) {
    const dialog = new Dialog(params, this);
    this.dialogs.push(dialog);
    this.notify();
    return dialog;
  }
  pop() {
    this.dialogs.pop();
    this.notify();
  }
  dismissAll(reason) {
    this.dialogs.forEach(d => d.dismiss(reason));
    this.dialogs = [];
    this.notify();
  }
}
exports.DialogStore = DialogStore;